import { memo, useMemo } from "react";
import { PrivatePageHeader } from "views/components/headers"
import { ButtonPrivateHeader } from "views/components/controles/buttons";
import { MenuIcon } from "views/components/icons";
import { useMenuPrincipal } from "services/app";
import { useThemeQueries } from "views";
import { RoadmapBacklogHeaderTipo } from "./components/roadmap-backlog-tipo/roadmap-backlog-tipo";

export interface RoadmapBacklogHeaderProps {
    isEmVotacao: boolean
}

export const RoadmapBacklogHeader = memo(({ isEmVotacao, ...props }: RoadmapBacklogHeaderProps) => {
    const { abrirMenu } = useMenuPrincipal();
    const { isMobile } = useThemeQueries();

    const leftArea = useMemo(() => (
        isMobile ?
            <ButtonPrivateHeader icon={<MenuIcon tipo="PRIVATE_HEADER"></MenuIcon>} tooltip="Menu" onClick={abrirMenu}></ButtonPrivateHeader> :
            null
    ), [isMobile, abrirMenu]);

    const pesquisa = useMemo(() => <RoadmapBacklogHeaderTipo />, [])

    return (
        <>
            <PrivatePageHeader
                title={isEmVotacao ? "Roadmap & Backlog" : "Histórico de Atualizações"}
                leftArea={leftArea}
                rightArea={pesquisa}
            />
        </>
    );
});

RoadmapBacklogHeader.displayName = "RoadmapBacklogHeader";
